import { useCallback, useState } from "react";
import { ProgressEmitter } from "_c/GlobalProgress/emitter";
export const useAsyncCallback = ({
  onError,
  onSuccess,
  callback: initialCallback,
  showProgress = true,
}) => {
  const [loading, setLoading] = useState(false);
  const callback = async (data) => {
    setLoading(true);
    if (showProgress) {
      ProgressEmitter.start();
    }
    try {
      const value = await initialCallback(data);
      if (onSuccess) {
        onSuccess(value, data);
      }
    } catch (e) {
      if (onError) {
        onError(e);
      }
    } finally {
      if (showProgress) {
        ProgressEmitter.end();
      }
      setLoading(false);
    }
  };
  return [callback, loading];
};
